export class AppApiEndpoints {
	public static nodes = {
		upload: {
			url: 'code/upload',
			method: 'POST',
			auth: false,
		},
		winners: {
			url: 'winners',
			method: 'GET',
			auth: false,
		},
		register: {
			url: 'user/register',
			method: 'POST',
			auth: false,
		},
	};
}



// WEBPACK FOOTER //
// ./src/app/app.api.endpoints.ts